import api from '../api';

const VehicleService = {
    getVehicleData: async (searchType, searchTerm, cancelToken) => {
        return api.get(`/Vehicule?$filter=${searchType} eq '${searchTerm}'&$format=json`, { cancelToken: cancelToken.token });
    }
};

export default VehicleService;
